//core
import React, {Fragment} from 'react';

//external
import Tabs from 'react-responsive-tabs';

//internal
import LegacyFacebookAD from "../LegacySettings/LegacyFacebookAD";
import FbAccountList from "./FbAccountList";
import LegacyFacebookLog from "../LegacySettings/LegacyFacebookLog";
import { getAppType } from '../../../Common/Appcommon';

const FaceBook = props => {

    function GetTabsContent () {

        const appType = getAppType();
        const tabsContent = [
            {
                title: 'Connect Account',
                content: <FbAccountList onBackAction={props.onBackAction} />,
                groupname : 'legacy',
            },
            {
                title: 'Map Field',
                content: <LegacyFacebookAD onBackAction={props.onBackAction} />,
                groupname : "legacy",
            },
            {
                title: 'View Log',
                content: <LegacyFacebookLog onBackAction={props.onBackAction} />,
                groupname : "legacy",
            }
        ];
        let modifiedTabs = tabsContent;
        if(appType === '0') {
            modifiedTabs = [];
            tabsContent.map((tab, index) => {
                if(tab.groupname !== "legacy"){
                    modifiedTabs.push(tab);
                }
            })
        }
        return modifiedTabs;
    }
    function getTabs() {
        let tabsContent = GetTabsContent();
        return tabsContent.map((tab, index) => ({
            title: tab.title,
            getContent: () => tab.content,
            key: index,
        }));
    }

    return (
        <Fragment>
            <Tabs
                tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding"
                transform={false}
                showInkBar={true}
                items={getTabs()}
            />
        </Fragment>
    )


}

export default FaceBook;